import * as React from "react";
const SvgFastForwardInverted = (props) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M3 14H1L1 2H3L8 7L8 2H10L16 8L10 14H8L8 9L3 14Z", fill: "currentColor" }));
export default SvgFastForwardInverted;
